import { ADD_USERS_COURSE_PAGE_KEY } from '../constants';
import type { TAssignUserTranslationKeys } from './types';

const en: TAssignUserTranslationKeys = {
  [ADD_USERS_COURSE_PAGE_KEY]: {
    TITLE_ADD_USER_COURSES: 'User Assignment',
    BACK_LABEL: 'Back',
    TITLE_TABLE: 'Select the users you want to assign to your course:',
    COURSE_LABEL: 'Course',
    LOADING_TITLE: 'Assigning users...',
    LOADING_DESCRIPTION: 'We will finish soon, thank you for waiting',
    ROLE_ALL: 'All',
    ROLE_ADMIN: 'Administrator',
    ROLE_USER: 'User',
    TITLE: 'Users',
    SEARCH: 'Search',
    SELECT_USER_ALL: 'Selected users in total',
    SELECT_USER: 'Selected users from this page',
    SELECT_USER_plural: 'User selected from this page.',
    SELECT_USER_ALL_LABEL: 'Select the {{totalUser}} users',
    COLUMN_NAME: 'Name',
    COLUMN_EMAIL: 'Error count',
    COLUMN_ROLE: 'Type',
    COLUMN_TAGS: 'Tags',
    COLUMN_STATUS: 'Status',
    SUCCES_ASSIGN: 'Successfully assigned *{{count}}* user to the course.',
    SUCCES_ASSIGN_plural:
      '*{{count}}* users were assigned to the course successfully.',
    SUCCES_SUBTITLE: 'These users will now be able to enjoy the course.',
    SUCCESS_DESCRIPTION:
      'You can now access the session details for more information.',
    SUCCESS_DESCRIPTION_ASYNC:
      '**Process may take longer than expected** We will notify you by mail upon completion',
    SUCCES_ASSIGN_ASYNC: 'You are assigning *{{count}}* users to the course.',
    SUCCES_ASSIGN_ASYNC_SUBTITLE:
      "Don't worry! we will send you an email informing you when your users have been successfully assigned to the course",
    BTN_ACTION: 'Assign users',
    BTN_ACTION_MANUAL: 'Assign users manually',
    BTN_ACTION_SEGMENTATION: 'Assign users by segmentation',
    BTN_CANCEL: 'Cancel',
    MODAL_SEGMENTATION_TITLE: 'Attribute Management',
    MODAL_SEGMENTATION_DESCRIPTION:
      'The selected attributes determine which users will be able to view the content of the selected category.',
    MODAL_CONFIRM_TITLE: 'Confirm user assignment',
    MODAL_CONFIRM_DESCRIPTION: 'Review selected users before continuing',
    MODAL_CONFIRM_MANUAL_USERS: 'Manually selected users',
    MODAL_CONFIRM_SEGMENT_USERS: 'Segment users',
    MODAL_CONFIRM_NO_USERS: 'No users in this group',
    MODAL_CONFIRM_USER_COUNT: '{{count}} user',
    MODAL_CONFIRM_USER_COUNT_plural: '{{count}} users',
    MODAL_CONFIRM_NO_NAME: 'No name',
    MODAL_CONFIRM_NO_EMAIL: 'No email',
    MODAL_SAVE_BTN: 'Save',
    MODAL_CANCEL_BTN: 'Cancel',
    ERROR_TITLE: 'An unexpected error occurred',
    ERROR_SUBTITLE: 'Please try again',
    ERROR_BTN: 'Understand',
    BTN_LABEL: 'Understood',
    SELECT_CATEGORY: 'Select a category',
    SELECT_EMPTY: 'No results found',
    SELECT_EMPTY_SUBTITLE: 'Try more general keywords',
    STATUS_ACTIVE: 'Active',
    STATUS_PENDING: 'Pending',
    TAB_TITLE: 'How do you want to add users to the course?',
    TAB_SUBTITLE: 'Choose the option of your preference to assign users',
    TAB_MANUAL: 'Manually',
    TAB_MASSIVE: 'Massively',

    MASSIVE_FIRST_STEP: 'Use the Excel template',
    MASSIVE_FIRST_STEP_DOWNLOAD_TEMPLATE: 'Download template',
    MASSIVE_SECOND_STEP: "Enter your users' email.",
    MASSIVE_THIRD_STEP: 'Upload the Excel file and \nclick on “Next”.',
    STEP_2_TITLE: 'Validate Data',
    STEP_2_ERROR_TITLE: 'Error in data validation',
    STEP_2_VALIDATION_ERROR: 'View error detail',
    STEP_2_POPPER_ERROR_2_TITLE: 'Records not found',
    STEP_2_POPPER_ERROR_2_SUBTITLE:
      'Ensure that the template you want to upload is not empty, each record must have the email data.',
    STEP_2_POPPER_ERROR_2_BUTTON: 'Reload the file',
    STEP_2_TABLE_TITLE: 'Validating user data...',
    STEP_2_VALIDATION_TITLE: 'Evaluating requirements:',
    STEP_2_VALIDATION_1: 'Validating file header',
    STEP_2_VALIDATION_2: 'Checking the number of users to assign',
    STEP_2_VALIDATION_3: 'Verifying email addresses',
    STEP_2_POPPER_ERROR_3_TITLE: 'Incorrect template',
    STEP_2_POPPER_ERROR_3_SUBTITLE:
      'We recommend downloading the suggested template. After filling it out correctly, you can come back and upload it again.',
    STEP_2_POPPER_ERROR_3_BUTTON: 'Download template',
    STEP_2_POPPER_ERROR_1_TITLE: 'An unexpected error occurred',
    STEP_2_POPPER_ERROR_1_SUBTITLE:
      'It seems there was a problem uploading your file, please try again',
    STEP_2_POPPER_ERROR_1_BUTTON: 'Try again',

    MASSIVE_STEP_UP: 'Upload file',
    MASSIVE_STEP_VALIDATION: 'Validate data',
    MASSIVE_STEP_DETAIL: 'Validation details',
    MASSIVE_HEADER_DOWNLOAD: 'Download template',
    MASSIVE_HEADER_FILE: "Enter your user's email address",
    MASSIVE_HEADER_NEXT: 'Upload the **Excel file** and click "Next".',
    MASSIVE_HEADER_DOWNLOAD_TITLE: 'Use the Excel template',
    MASSIVE_ERROR_STEP_1: 'Invalid format',
    MASSIVE_ERROR_STEP_1_REPLACE: 'Load another file',
    MASSIVE_ERROR_STEP_1_SUBTITLE:
      'Make sure the file is in a valid format, such as .xlsx or .csv. ',
    MASSIVE_STEP_1_TITLE: 'Select your file',
    MASSIVE_STEP_1_SUBTITLE: 'Or drag and drop the .xlsx file to load it',
    MASSIVE_STEP_1_SIZE: 'Max weight 500kb',
    MASSIVE_STEP_1_IMPORTATION: 'Past imports',
    MASSIVE_STEP_2_TITLE: 'Validating data',
    MASSIVE_STEP_2_SUBTITLE: 'Validating user data...',
    MASSIVE_STEP_2_EVALUATION: 'Evaluating the requirements',
    STEP_NEXT: 'Next',
    STEP_FINISHED: 'Add users',
    MASSIVE_STEP_3_SUCCESS: 'Emails validated successfully',
    MASSIVE_STEP_3_SUCCESS_NOTE:
      'We have detected duplicate emails, which will be merged to ensure that they are considered only once in the course.',
    MASSIVE_STEP_3_WARNING: 'Emails previously registered in the course',
    MASSIVE_STEP_3_WARNING_NOTE:
      'We have identified emails that are already registered in this course. These emails will not be assigned again',
    MASSIVE_STEP_3_ERROR: 'Emails with errors',
    MASSIVE_STEP_3_ERROR_NOTE:
      'By continuing with the validation these users will not be added to the course',
    MASSIVE_STEP_3_ERROR_NO_EMAIL: 'Unregistered emails in your organization',
    MASSIVE_STEP_3_ERROR_FORMAT_EMAIL: 'Invalidly formatted emails',
    MASSIVE_STEP_3_ERROR_DISABLED_EMAIL: 'Deleted or inactive user emails',
    MASSIVE_STEP_3_ERROR_DOWNLOAD: 'Download errors',
    MASSIVE_STEP_2_DETAIL:
      'Download the error detail so you can correct them and upload the file again. Or if you wish, you can continue with the upload of only successfully validated users.',
    MASSIVE_FINISHED_TITLE: '*{{count}}* users are being added to the course',
    MASSIVE_FINISHED_DESCRIPTION:
      'This process may take a little longer than expected, you will be notified as soon as the process is finished.  ',
    ERROR_PERCENTAGE: 'An error occurred',
    COLUMN_REGISTER: 'NO RECORDS',
    COLUMN_USER: 'User',
    COLUMN_UPLOAD_DATE: 'Date of import',
    COLUMN_DETAIL_ERROR: 'Error detail',
    ERROR_SIZE_TITLE: 'File weight exceeded',
    ERROR_SIZE:
      'The file you tried to add exceeds the maximum allowed weight of {{size}} MB.',
    ERROR:
      'Try loading the file again. If the problem persists you can try again later',
    FILE_REEMPLACE_CUSTOM: 'Choose another file',
    FILE_UPLOAD_CUSTOM: 'Upload file',
    FILE_DURATION_CUSTOM: '0 minutes',
    FILE_TIME: '{{progress}}% - {{duration}} to finish',
    SWITCH_NOTIFICATION_NEW: 'New',
    SWITCH_NOTIFICATION_TITLE: 'Send mail to contributors',
    SWITCH_NOTIFICATION_MESSAGE:
      ' Serves to notify your assignees about their new route. If you requested not to receive mails, they will not be sent even if the option is activated',
    SWITCH_NOTIFICATION_DIALOG_TITLE_plural: '*{{count}}* emails will be sent',
    SWITCH_NOTIFICATION_DIALOG_TITLE: '*{{count}}* mail will be sent',
    SWITCH_NOTIFICATION_DIALOG_1:
      'You have enabled the option to **send a mail notifying the selected collaborators** of the route assignment.',
    SWITCH_NOTIFICATION_DIALOG_2:
      'If you prefer not to send the mails, deactivate this option at the top of the user table.',

    SWITCH_NOTIFICATION_COURSES_MESSAGE:
      'Serves to notify your assignees about their new course. If you requested not to receive mails, they will not be sent even if the option is activated',
    SWITCH_NOTIFICATION_DIALOG_COURSES_1:
      'You have enabled the option to **send a mail notifying the selected collaborators** of the course assignment.',
    SUCCESS_DESCRIPTION_COURSE:
      'You can now access the course details for more information.',
    FILTER_HINT: 'Filter by',
  },
};

export default en;
